import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Badge,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    List,
    ListItem,
    ListItemButton, ListItemText,
    TextField,
    Tooltip,
} from '@mui/material';
import { Inventory } from '@mui/icons-material';
import { ChatModel } from 'models/ChatModel';


type ChatListCardProps = {
    chats: ChatModel[],
    current?: ChatModel,
    closeChat: (code: string) => void,
    setCurrent: (v: string) => void,
}

const ChatList = ({chats, current, closeChat, setCurrent}: ChatListCardProps) => {
    const {t} = useTranslation();
    const [filter, setFilter] = useState('');

    const filtered = filter ? chats.filter(c => c.name.toLowerCase().includes(filter)) : chats;

    return (
        <Card sx={{height: '100%', borderRadius: 0}}>
            <CardHeader
                title={t('chats')}
                // action={addButton}
            />

            <CardContent>
                <TextField
                    id="chatFilter"
                    label={t('filter')}
                    fullWidth
                    margin="none"
                    value={filter}
                    onChange={e => setFilter(e.target.value.toLowerCase())}
                />
            </CardContent>

            <List
                dense
                sx={{
                    height: 'calc(100vh - 180px)',
                    overflow: 'auto',
                }}
            >
                {filtered.map(chat => (
                    <ListItem
                        key={chat.code}
                        secondaryAction={
                            <Tooltip
                                title={t('archive_chat')}
                                placement="left"
                            >
                                <IconButton
                                    edge="end"
                                    aria-label="close chat"
                                    onClick={() => closeChat(chat.code)}
                                >
                                    <Inventory/>
                                </IconButton>
                            </Tooltip>
                        }
                        disablePadding
                    >
                        <ListItemButton
                            selected={chat.code === current?.code}
                            onClick={() => setCurrent(chat.code)}
                        >
                            <ListItemText primary={chat.name} />
                            <Badge
                                badgeContent={chat.unreadCount}
                                color="primary"
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Card>
    )
};

export default ChatList;
